import { Locale } from '@types-internal';

type FallbackNeededLocale = Extract<
  Locale,
  'bg-BG' | 'de-AT' | 'de-CH' | 'en' | 'en-GB' | 'en-IE' | 'fr-BE' | 'fr-CH' | 'nb-NO' | 'zu'
>;

const adyenLocaleFallbacks: Record<FallbackNeededLocale, string> = {
  'bg-BG': 'en-US', // at the time of this writing, Bulgarian is not supported by Adyen ; I guess the least bad fallback is English.
  'de-AT': 'de-DE',
  'de-CH': 'de-DE',
  en: 'en-US',
  'en-GB': 'en-US',
  'en-IE': 'en-US',
  'fr-BE': 'fr-FR',
  'fr-CH': 'fr-FR',
  'nb-NO': 'no-NO',
  zu: 'en-US',
};

// same locale for us and for Adyen: cs-CZ, da-DK, el-GR, es-ES, fi-FI, fr-FR, hr-HR, hu-HU, it-IT, nl-NL, pl-PL, pt-PT, ro-RO, ru-RU, sk-SK, sl-SI, sv-SE
export function normalizeLocaleForAdyen(locale: Locale): string {
  const adyenLocale = adyenLocaleFallbacks[locale as FallbackNeededLocale];
  return adyenLocale ?? locale;
}
